import { render, staticRenderFns } from "./KusClientAccessVue.vue?vue&type=template&id=6517ac6c"
import script from "./KusClientAccessVue.vue?vue&type=script&lang=js"
export * from "./KusClientAccessVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports